// addresscurrentReducer.js

import {  SET_ADDRESS_DATA_CURRENT } from '../../actions/checkoutactions/checkoutActions';

// Anfangszustand
const initialState = {
  addressData: null // Anfangs ist keine Pickup-Location ausgewählt
};

// Reduzierer
const addresscurrentReducer = (state = initialState, action) => {
  switch (action.type) {
    case  SET_ADDRESS_DATA_CURRENT:
      return {
        ...state,
        addressData: action.payload // Setze die Pickup-Location
      };
    default:
      return state;
  }
};

export default addresscurrentReducer;